import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import store from '@/store/store';
import router from './router';
import VueLazyload from 'vue-lazyload';
import VTooltip from 'v-tooltip';
import VueHead from 'vue-head';
import VueSweetalert2 from 'vue-sweetalert2';
import Toasted from 'vue-toasted';
import NProgress from 'nprogress';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VTooltip);
Vue.use(VueHead);
Vue.use(VueSweetalert2);
Vue.use(Toasted);
Vue.use(VueCookies);

Vue.use(VueLazyload, {
  // set observer to true
  observer: true,

  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  }
});

// Global event bus for wizard
Vue.prototype.$wzBus = new Vue();
window.$wzBus = Vue.prototype.$wzBus;

Vue.config.productionTip = false;
sync(store, router);

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  mounted: function () {
    // Progress bar
    NProgress.configure({ easing: 'ease', speed: 500, showSpinner: true });

    store.watch(
      (state) => state.loading.loading,
      (newVal, oldVal) => {
        if (newVal === 0) return NProgress.done();
        if (oldVal === 0) return NProgress.start();
        NProgress.set(1.8 / Math.max(oldVal, newVal));
      }
    );
  },
  head: {
    script: [
      {
        src:
          'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/all.min.js',
        integrity: 'sha256-KzZiKy0DWYsnwMF+X1DvQngQ2/FxF7MF3Ff72XcpuPs=',
        crossorigin: 'anonymous'
      }
    ]
  },
  store
});
